import Controller from "@ember/controller";

export default class ChatIndexController extends Controller {}
